
// SEARCH PHOTO BY ID

export const FIND_MATCH_BEGIN = "FIND_MATCH_BEGIN" 

export const FIND_MATCH_SUCCESS = "FIND_MATCH_SUCCESS"

export const FIND_MATCH_FAILURE = "FIND_MATCH_FAILURE"

